// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"363":"css/admin-app.6882","9961":"css/app.6882"}[chunkId] + ".css";
};